import styled from 'styled-components';

import FormField from '~/shared/components/FormField';
import {body13Bold} from '~/shared/theme/typography';
import {getLocalizationService} from '~/shared/services/localisationService';
import {COMMENT_MAX_LENGTH} from '~/shared/consts/addressConsts';

import {AddressDropdownButton} from '../../styled.addressDropdown';

const ShowCommentsButton = styled(AddressDropdownButton).attrs({
  'data-test-id': 'openCommentFieldBtn',
})`
  border: none;
  background: none;
  ${body13Bold};
  color: ${({theme}) => theme.colors.surfacePrimaryAction};
  text-decoration: underline;
`;

const CommentsField = ({isCommentsExpended, setIsCommentsExpended}) => {
  const {t} = getLocalizationService();
  if (isCommentsExpended) {
    return (
      <FormField
        name="comments"
        label="address_comments"
        type="textarea"
        fullHeight={false}
        placeholder={t('address_comments')}
        inputProps={{maxLength: COMMENT_MAX_LENGTH}}
      />
    );
  }
  return (
    <ShowCommentsButton onClick={() => setIsCommentsExpended(true)}>
      {t('i_have_notes_for_the_delivery_guy')}
    </ShowCommentsButton>
  );
};
export default CommentsField;
